/**
 * @description Interfaces for the functions that will be exposed to the global scope used by tenants.
 */
// publish
import { publish } from "./emitter-subscriber/publish";
// types
import { interfaceLayerName } from "./types";
(() => {
    const functions = {
        // ***************
        // AAT FUNCTIONS
        // ***************
        passive: () => {
            publish("AAT_INITIALIZE_PASSIVE");
        },
        config: (record) => {
            publish("AAT_CONFIG_PASSIVE", record);
        },
        flush: (record) => {
            publish("AAT_FLUSH_PASSIVE", record);
        },
        event: (record) => {
            publish("AAT_EVENT_PASSIVE", record);
        },
        observeElements: () => {
            publish("AAT_OBSERVE_ELEMENT_PASSIVE");
        },
        observeUpdates: (record) => {
            publish("AAT_OBSERVE_UPDATES", record);
        },
        unobserveUpdates: () => {
            publish("AAT_UNOBSERVE_UPDATES");
        },
        pageView: (record) => {
            publish("AAT_PAGE_VIEW", record);
        },
        time: (record) => {
            publish("AAT_TIME_PASSIVE", record);
        },
        timeEnd: (record) => {
            publish("AAT_TIME_END_PASSIVE", record);
        },
        userProfileId: (record) => {
            publish("AAT_USER_PROFILE_ID", record);
        },
        // ***************
        // AAT FUNCTIONS
        // ***************
        send: (record) => {
            publish("JOURNEY_RECORD", record);
        },
        /**
         * @function addUserProfileID
         * @description Adds a user profile ID and publishes the event.
         * @param {string} [param] - The user profile ID to add.
         */
        addUserProfileID: (param) => {
            if (param)
                publish("ADD_USERPROFILEID", { id: param });
        },
        /**
         * @function trackElements
         * @description Tracks elements and publishes the event.
         */
        trackElements: () => {
            publish("TRACK_ELEMENTS");
        },
        recordPageView: (record) => {
            publish("RECORD_PAGE_VIEW", record);
        },
        flushJourney: (record) => {
            publish("JOURNEY_FLUSH", record);
        },
        allowCookies: (record) => {
            publish("ALLOW_COOKIES", record);
        },
        addSessionAttributes: (record) => {
            publish("ADD_SESSION_ATTRIBUTES", record);
        },
        /**
         * @function recordJourney
         * @description Records a journey and publishes the event.
         * @param {any} record - The record object containing journey details.
         */
        recordJourney: (record) => {
            publish("JOURNEY_RECORD", record);
        },
        // new functions
        // new functions
        clear: (record) => {
            publish("CLEAR", record);
        },
        // new functions
        /**
         * @function completeJourney
         * @description Completes a journey and publishes the event.
         * @param {string} [param] - The name of the journey to complete.
         */
        completeJourney: (param) => {
            if (param)
                publish("JOURNEY_COMPLETED", { journeyName: param });
            else
                publish("JOURNEY_COMPLETED");
        },
    };
    /**
     * @function window[interfaceLayerName]
     * @description Executes a function from the global scope with the given name and parameters.
     * @param {string} funcName - The name of the function to execute.
     * @param {...any[]} params - The parameters to pass to the function.
     */
    window[interfaceLayerName] = (funcName, ...params) => {
        const func = functions[funcName];
        if (func) {
            func.apply(this, params);
        }
        else {
            console.warn(`Function ${funcName} not found.`);
        }
    };
})();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/global-functions.js
// module id = ./node_modules/@celine/passive-tracking/dist/global-functions.js
// module chunks = 0